import { ReactNode, createContext } from 'react';
import { StoreApi, createStore } from 'zustand';

import { WaterfallZoomState, storeFactory } from './useWaterfallZoomState';

export const WaterfallZoomContext =
  createContext<StoreApi<WaterfallZoomState> | null>(null);
// Provider component that creates a new store instance
export function WaterfallZoomProvider({ children }: { children: ReactNode }) {
  const store = createStore(storeFactory);

  return (
    <WaterfallZoomContext.Provider value={store}>
      {children}
    </WaterfallZoomContext.Provider>
  );
}
